var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 71,
    viewBox: "0 0 387 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385 35.5C385 37.1567 384.092 39.051 381.734 41.1654C379.383 43.2735 375.8 45.4008 370.998 47.4834C361.411 51.642 347.414 55.4339 329.965 58.6351C295.099 65.0316 246.851 69 193.5 69C140.15 69 91.9012 65.0316 57.0361 58.6351C39.5872 55.4339 25.5901 51.642 16.0024 47.4834C11.2011 45.4008 7.61811 43.2735 5.26669 41.1654C2.90845 39.051 2.00037 37.1567 2.00037 35.5C2.00037 33.8433 2.90845 31.949 5.26669 29.8346C7.61811 27.7265 11.2011 25.5992 16.0024 23.5166C25.5901 19.358 39.5872 15.5661 57.0361 12.3649C91.9012 5.96843 140.15 2 193.5 2C246.851 2 295.099 5.96843 329.965 12.3649C347.414 15.5661 361.411 19.358 370.998 23.5166C375.8 25.5992 379.383 27.7265 381.734 29.8346C384.092 31.949 385 33.8433 385 35.5Z",
    stroke: "url(#paint0_radial)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9359 -57.51) rotate(43.552) scale(197.399 972.813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.86d8dfe00ceeb2638f186e8e502c0276.svg";
export { ForwardRef as ReactComponent };